import { createFeatureSelector, createSelector } from '@ngrx/store';
import { selectAll, selectEntities, State } from './lib/site/site.reducer';

export * from './lib/shared-site-data-access.module';
export * from './lib/site-api/site-api.actions';
export * from './lib/site-api/site-api.effects';
export * from './lib/site-ws/site-ws.actions';
export * from './lib/site-ws/site-ws.effects';
export * from './lib/site/site.actions';
export * from './lib/site/site.model';

export const getState = createFeatureSelector<State>('site');

export const getSites = createSelector(getState, selectAll);

export const getSiteEntities = createSelector(getState, selectEntities);
